import { get, writable } from "svelte/store";
import { LocalStorage } from "$/services/LocalStorage.js";
const INTRO_MODAL_KEY = "IntroModal";
class IntroModal {
    constructor() { }
}
const store = () => {
    // create store
    const { subscribe, set, update } = writable(new IntroModal());
    return {
        subscribe,
        set: (value) => {
            LocalStorage.set(INTRO_MODAL_KEY, value);
            set(value);
        },
        update,
        init: async () => {
            let localValue = await LocalStorage.get(INTRO_MODAL_KEY);
            if (localValue) {
                set(localValue);
            }
        },
    };
};
export const IntroModalStore = store();
LocalStorage.subscribe(INTRO_MODAL_KEY, (event) => {
    if (event.newValue !== event.oldValue) {
        IntroModalStore.set(event.newValue);
    }
});
